import React from 'react';
import { Pagination, Table } from 'antd';
import { TUnionTableData, TColumns } from 'shared/types/types';
import { useScrollUpPage } from 'shared/hooks';
import SearchComponent from 'shared/components/search/news-faq';
import { SearchKeysNews } from 'shared/enums/news';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import style from './index.module.scss';

type TProps = {
  dataSource: TUnionTableData;
  columns: TColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onSearch?: (data: string, key: SearchKeysNews) => void;
  onRowClick?: (record: TUnionTableData[number]) => void;
};

export const TablePull = ({
  dataSource,
  columns,
  currentPage,
  setCurrentPage,
  total,
  setCurrentSize,
  currentSize,
  onSearch,
  onRowClick,
}: TProps) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  useScrollUpPage(currentPage);

  return (
    <>
      <SearchComponent
        selectOptions={{
          [SearchKeysNews.SEARCH_NAME]: {
            name: SearchKeysNews.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysNews.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysNews.SEARCH_ID]: {
            name: SearchKeysNews.SEARCH_ID,
            alias: 'Номер заявки',
            node: NumberFormItem({
              name: SearchKeysNews.SEARCH_ID,
              placeholder: 'Введите номер заявки',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_ID);
              },
            }),
          },
          [SearchKeysNews.PERSONNEL_NUMBER]: {
            name: SearchKeysNews.PERSONNEL_NUMBER,
            alias: 'ТН',
            node: StringFormItem({
              name: SearchKeysNews.PERSONNEL_NUMBER,
              placeholder: 'Введите ТН',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.PERSONNEL_NUMBER);
              },
            }),
          },
          [SearchKeysNews.POSITION_NAME]: {
            name: SearchKeysNews.POSITION_NAME,
            alias: 'Должность',
            node: StringFormItem({
              name: SearchKeysNews.POSITION_NAME,
              placeholder: 'Введите должность',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.POSITION_NAME);
              },
            }),
          },
          [SearchKeysNews.DIVISION_NAME]: {
            name: SearchKeysNews.DIVISION_NAME,
            alias: 'Подразделение',
            node: StringFormItem({
              name: SearchKeysNews.DIVISION_NAME,
              placeholder: 'Введите подразделение',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.DIVISION_NAME);
              },
            }),
          },
        }}
      />

      <Table
        scroll={{ x: true }}
        dataSource={dataSource}
        columns={columns}
        rowClassName={record => {
          if (!('consultant' in record)) {
            return '';
          }
          if (record.downtimeStatus === 'red') {
            return style.red;
          } else if (record.downtimeStatus === 'yellow') {
            return style.yellow;
          }
          return style.blue;
        }}
        pagination={false}
        bordered
        onRow={record => ({
          onClick: () => {
            onRowClick?.(record);
          },
        })}
      />
      <div className={style.paginationWrap}>
        <Pagination
          defaultCurrent={1}
          showSizeChanger
          current={currentPage}
          total={total}
          pageSize={currentSize}
          onChange={(page, pageSize) => handlePagination(page, pageSize)}
        />
      </div>
    </>
  );
};
